import axios from "axios";
import { addUserFullDesignProfessionals } from "../../store/actions/userActions";
import { addSubUserFullDesignProfessionals } from "../../store/actions/subUserActions";
import { addPPUserFullDesignProfessionals } from "../../store/actions/privateProviderActions";
import {
  handleSaveProjects,
  removeBonding,
  removeFeeSimple,
  removeMortgage,
  removeTermite,
  removePrivateProvider,
  removeSavedProject,
} from "../../store/actions/dataActions";
import { setBuildingState } from "../../store/actions/permitFormActions/buildingStateActions";
import { setBuildingPermitModals } from "../../store/actions/permitFormActions/modalControlStateActions";

//! HANDLE REMOVE PROJECTS AND DESIGN PRO /////////////////////////////////////////////
export const handleDesignProRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
  { selectorName = "designProfessional", selectedId = "" } = {},
) => {
  const designProfessionalId =
    selectedId ||
    formikValues?.[selectorName] ||
    formikValues?.designProfessional;

  if (!designProfessionalId) return;

  await dispatch(async (innerDispatch, getState) => {
    const currentSession = getState().sessions?.currentSession;

    try {
      innerDispatch(setBuildingState({ designProLoading: true }));

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/building/modify-design-professional`,
        {
          values: {
            removeData: true,
            id: designProfessionalId,
          },
          currentSession,
        },
        { withCredentials: true },
      );

      if (!resp?.data?.success) {
        alert(
          resp?.data?.message ||
            "Unable to remove the design professional. Please try again.",
        );
        return;
      }

      const designProfessionals = resp?.data?.design_professionals || [];

      if (currentSession === "privateProviderSession") {
        innerDispatch(addPPUserFullDesignProfessionals(designProfessionals));
      } else if (currentSession === "subUserSession") {
        innerDispatch(addSubUserFullDesignProfessionals(designProfessionals));
      } else {
        innerDispatch(addUserFullDesignProfessionals(designProfessionals));
      }

      formikSetValues({
        ...formikValues,
        [selectorName]: "",
        design_pro_company: "",
        design_pro_license_name: "",
        design_pro_license_num: "",
        design_pro_address: "",
        design_pro_phone: "",
        design_pro_fax: "",
        design_pro_email: "",
        engineer_name: "",
        engineer_full_address: "",
        engineer_street: "",
        engineer_city: "",
        engineer_state: "",
        engineer_zip: "",
        engineer_phone: "",
        engineer_email: "",
        engineer_license_num: "",
        architect_name: "",
        architect_phone: "",
        architect_email: "",
      });

      innerDispatch(
        setBuildingPermitModals({ addDesignProConfirmOpen: false }),
      );
      innerDispatch(
        setBuildingState({
          addingNewDesignPro: false,
          activeTemplateCategory: null,
          submitDisabled: false,
        }),
      );
    } catch (error) {
      alert(
        error?.response?.data?.message ||
          "Unable to remove the design professional. Please try again.",
      );
    } finally {
      innerDispatch(setBuildingState({ designProLoading: false }));
    }
  });
};

export const handleProjectRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the design professional from the Redux store

  await dispatch(removeSavedProject(formikValues.projectContact));
  formikSetValues({
    ...formikValues,
    projectContact: "",
    project_contact: "",
    project_c_phone: "",
  });
  await dispatch(setBuildingPermitModals({ projectConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({ addingNewProject: false, projectSubmitDisabled: false }),
  );
};

export const handleFeeSimpleRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeFeeSimple(formikValues.feeSimpleTitleholder));
  formikSetValues({
    ...formikValues,
    feeSimpleTitleholder: "",
    fee_simple_name: "",
    fee_simple_address: "",
  });

  dispatch(setBuildingPermitModals({ feeSimpleConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewFeeSimple: false,
      feeSimpleSubmitDisabled: false,
    }),
  );
};

export const handleBondingRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeBonding(formikValues.bondingCompany));
  formikSetValues({
    ...formikValues,
    bondingCompany: "",
    bonding_name: "",
    bonding_address: "",
  });
  dispatch(setBuildingPermitModals({ bondingConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewBonding: false,
      bondingSubmitDisabled: false,
    }),
  );
};

export const handleMortgageRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the design professional from the Redux store
  await dispatch(removeMortgage(formikValues.mortgageLender));
  formikSetValues({
    ...formikValues,
    mortgageLender: "",
    mortgage_name: "",
    mortgage_address: "",
  });
  dispatch(setBuildingPermitModals({ mortgageConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewMortgage: false,
      mortgageSubmitDisabled: false,
    }),
  );
};

export const handleTermiteRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the termite from the Redux store
  await dispatch(removeTermite(formikValues.termite));
  formikSetValues({
    ...formikValues,
    termite: "",
    protection_by: "",
    treatment_method: "",
  });
  dispatch(setBuildingPermitModals({ termiteConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewTermite: false,
      termiteSubmitDisabled: false,
    }),
  );
};

export const handlePrivateProviderRemove = async (
  formikValues,
  formikSetValues,
  dispatch,
) => {
  // Dispatch the action to remove the private provider from the Redux store
  await dispatch(removePrivateProvider(formikValues.privateProvider));
  formikSetValues({
    ...formikValues,
    privateProvider: "",
    pp_company_name: "",
    pp_address: "",
    pp_phone: "",
    pp_email: "",
    pp_name: "",
    pp_license: "",
  });
  dispatch(setBuildingPermitModals({ privateProviderConfirmModalOpen: false }));
  dispatch(handleSaveProjects());

  dispatch(
    setBuildingState({
      addingNewPrivateProvider: false,
      privateProviderSubmitDisabled: false,
    }),
  );
};
